import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, first, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EventsExportRequest } from '../models/eventsExport';
import { TraceExportRequest } from '../models/traceListElements';
import { ApiService } from './api.service';
import { DownloadService } from './download.service';
import { MainSubscriptionsService } from './main-subscriptions/main-subscriptions.service';

// The exports the backend serves as a file minted for one download: the API
// answers with its link, the browser (or the system browser on native) fetches
// it with the short-lived token as the only credential.
@Injectable({ providedIn: 'root' })
export class EventsExportService {
  private readonly apiService = inject(ApiService);
  private readonly mainService = inject(MainSubscriptionsService);
  private readonly download = inject(DownloadService);

  public export(request: EventsExportRequest): Observable<boolean> {
    return this.open(this.apiService.requestEventsExport(request));
  }

  public exportTraces(request: TraceExportRequest, domainOnly: boolean): Observable<boolean> {
    return this.open(domainOnly ? this.apiService.exportDomainTraces(request) : this.apiService.exportTraces(request));
  }

  private open(response$: Observable<{ Url: string }>): Observable<boolean> {
    return response$.pipe(
      first(),
      map(response => {
        if (!response?.Url) {
          this.mainService.setCustomErrorComand('EXPORT.FAILED');
          return false;
        }

        this.download.open(`${environment.apiUrl}${response.Url}`);
        return true;
      }),
      catchError(err => {
        const message: string = err?.error?.Message ?? '';
        this.mainService.setCustomErrorComand(
          message.includes('range exceeds') ? 'EXPORT.RANGE_TOO_WIDE' : 'EXPORT.FAILED');
        return of(false);
      }),
    );
  }
}
